<template>
  <div>
    <chart-card
      ref="card"
      v-if="data.labels && data.labels.length"
      header-animation="false"
      :chart-data="data"
      :chart-options="multipleBarsChart.options"
      :chart-type="mode"
      header-icon
      :chart-inside-content="showChart"
      :no-footer="!showChart"
      background-color="brand"
    >
      <template slot="chartInsideHeader">
        <div class="card-icon">
          <md-icon>insert_chart</md-icon>
        </div>

        <md-button
          class="md-just-icon md-round modal-default-button md-simple"
          @click="showChart = !showChart"
        >
          <md-icon v-if="showChart"> minimize </md-icon>
          <md-icon v-else-if="!showChart"> maximize </md-icon>
        </md-button>
      </template>
      <template slot="footer" md-alignment="right">
        <div class="footer">
          <slot name="actions"> </slot>
          <span
            v-for="(legend, index) in data.legend"
            :key="index"
            class="legend-span"
          >
            <i class="fa fa-circle" :class="legendColors[index]"></i>
            {{ legend }}
          </span>
          <md-button
            @click="changeColumns('mode')"
            class="md-lg md-just-icon md-simple chart-mode-button"
          >
            <md-icon v-if="mode === 'Bar'"> timeline </md-icon>
            <md-icon v-else-if="mode === 'Line'"> insert_chart </md-icon>
          </md-button>
          <md-field class="column-select">
            <label> # Kolona </label>
            <md-select v-model="columns">
              <md-option
                v-for="option in columnOptions"
                :key="option"
                :value="option"
              >
                {{ option }}
              </md-option>
            </md-select>
          </md-field>
        </div>
      </template>
    </chart-card>
  </div>
</template>
<script>
import { ChartCard } from '@/components';
export default {
  components: {
    ChartCard,
  },
  props: {
    data: Object,
  },
  computed: {
    columnOptions() {
      const numOfOptions = this.maxColumns - this.minColumns;
      const columnOptions = [];
      for (let i = 0; i <= numOfOptions; i++) {
        columnOptions.push(this.minColumns + i);
      }
      return columnOptions;
    },
  },
  data() {
    return {
      columns: 12,
      minColumns: 3,
      maxColumns: 24,
      mode: 'Bar',
      modes: ['Bar', 'Line'],
      showChart: true,
      legendColors: ['text-primary', 'text-danger', 'text-warning'],
      multipleBarsChart: {
        options: {
          seriesBarDistance: 10,
          axisX: {
            showGrid: false,
          },
          axisY: {
            offset: 80,
            labelInterpolationFnc: value => {
              if (Math.max(...this.data.series.flat()) >= 5000)
                return value / 1000 + ' K€';
              else return value + ' €';
            },
            scaleMinSpace: 15,
          },
          height: '300px',
        },
        responsiveOptions: [
          [
            'screen and (max-width: 640px)',
            {
              seriesBarDistance: 5,
              axisX: {
                labelInterpolationFnc(value) {
                  return value[0];
                },
              },
            },
          ],
        ],
      },
    };
  },
  methods: {
    changeColumns(direction) {
      if (direction === 'add') this.columns++;
      else if (direction === 'sub') this.columns--;
      else if (direction === 'mode') {
        this.mode = this.modes[this.modes.findIndex(el => el !== this.mode)];
        this.$emit('column-update', this.mode);
      }
    },
    updateChart() {
      if (this.$refs.card) this.$refs.card.updateChart();
    },
  },
  watch: {
    columns() {
      this.$emit('column-update');
    },
  },
};
</script>

<style scoped>
.chart-mode-button {
  padding-right: 3em;
}
.minimize-button {
  position: absolute;
  right: 2em;
  top: 0.5em;
}
.legend-span {
  margin-right: 1em;
}
.column-select {
  width: 7em;
  margin: 1.2em 0.5em 0 0.5em;
}
.footer {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  gap: 1em;
}
</style>
